import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { ResponseTypeEnum } from '../models/enums';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
var JobLevelService = /** @class */ (function () {
    function JobLevelService(http) {
        var _this = this;
        this.http = http;
        this.getJobLevelList = function () {
            return _this.http.Get(URLS.getJobLevelList);
        };
        this.getJobLevel = function (jobLevelId) {
            return _this.http.Get(URLS.getJobLevel + "/" + jobLevelId);
        };
        this.saveJobLevel = function (jobLevel) {
            return _this.http.Post(URLS.saveJobLevel, jobLevel, ResponseTypeEnum.Success);
        };
        this.deleteJobLevel = function (jobLevelId) {
            return _this.http.Delete(URLS.deleteJobLevel + "/" + jobLevelId, ResponseTypeEnum.Success);
        };
    }
    JobLevelService.ngInjectableDef = i0.defineInjectable({ factory: function JobLevelService_Factory() { return new JobLevelService(i0.inject(i1.BaseHttpService)); }, token: JobLevelService, providedIn: "root" });
    return JobLevelService;
}());
export { JobLevelService };
